const { includeFragment } = require('./include-fragment')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} html
 * @param {boolean} isFragment
 * @param {string|null} type
 * @param {RegExp|null} replaceRegExp
 * @param {string|null} stateId
 * @returns {*}
 */
function parseHtml ({ html, isFragment = false, type = null, replaceRegExp = null, stateId = '__CL_STATE__' } = {}) {
  if (!html) return

  let output = includeFragment(html)
  output = output.replace('__INITIAL_STATE__', stateId)

  if (type === 'head') {
    return output
      .match(/<head[^>]*>[\W\w]*<\/head>/gm)[0]
      .replace(/<\/?head[^>]*>/g, '')
      .replace(/\s{2,}/gm, ' ')
  }

  if (type === 'scripts') {
    return output
      .match(/<script[^>]*>[^<]*<\/script>/gm)
      .join('')
  }

  if (replaceRegExp) {
    output = output.replace(replaceRegExp, '')
  }

  if (type === 'body') {
    return output
      .replace(/<head[^>]*>[\W\w]*<\/head>/gm, '')
      .replace(/<script[^>]*>[^<]*<\/script>/gm, '')
  }

  if (isFragment) {
    output = output.replace(/<html.*>/, '')
    output = output.replace(/<head.*>/, '')
    output = output.replace(/<body.*>/, '')
    output = output.replace('<!DOCTYPE html>', '')
    output = output.replace('</html>', '')
    output = output.replace('</head>', '')
    output = output.replace('</body>', '')
    output = `<div>${output}</div>`
  }

  return output
}

module.exports = { parseHtml }
